import { getHomePath } from "@shared/common/node/condition";
import type { ExternalSiteCheckRule } from "../../types";
import { SITE_TYPE } from "./const";

const oopy: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  // TODO: OOPY 지원
  checkPage({ url, target, siteUrl }) {
    if (target.value === "HOME" && url.pathname === getHomePath(siteUrl)) {
      return true;
    }

    return false;
  },
};

export default oopy;
